import React from 'react';
import { QUADRANTS, quadrantOf, sortTasks } from '../myDayUtils';
import TaskRow from './TaskRow';

/**
 * Eisenhower matrix over everything still open. Urgency comes from the date and
 * priority; importance is the flag on the task, so the two axes stay independent.
 */
export default function MatrixView({ tasks, cats, today, onToggle, onOpen, onAction }) {
  const open = tasks.filter(t => !t.done && !t.archived);

  return (
    <div className="md-matrix">
      <p className="md-lead">
        Urgent is anything due today or flagged P1/P2. Important is the flag you set on the
        task itself — open one and tick <em>Important</em> to move it up a row.
      </p>
      <div className="md-matrix__grid">
        {QUADRANTS.map(q => {
          const items = sortTasks(open.filter(t => quadrantOf(t, today) === q.id));
          return (
            <section key={q.id} className="md-quad" style={{ '--quad': q.color }}>
              <header className="md-quad__head">
                <span className="md-quad__dot" aria-hidden="true" />
                <h3 className="md-quad__title">{q.title}</h3>
                <span className="md-quad__hint">{q.hint}</span>
                <span className="md-quad__count">{items.length}</span>
              </header>
              {items.length === 0 ? (
                <p className="md-empty md-empty--sm">Nothing here.</p>
              ) : (
                <ul className="md-list">
                  {items.map(t => (
                    <TaskRow key={t.id} task={t} cats={cats} today={today} showDate
                      onToggle={onToggle} onOpen={onOpen} onAction={onAction} />
                  ))}
                </ul>
              )}
            </section>
          );
        })}
      </div>
    </div>
  );
}
